/*
 * Copyright (c) Nexign, JSC, 2019.
 */
/**
 *
 * @author Evgenij Tyan
 * @version 1.0.1
 * @since 1.0.0
 */

/**
 * Editing
 */
export const SUPER_SEARCH_CLEAR = '@@b2b_portal_ui/superSearch/SUPER_SEARCH_CLEAR';
export const SUPER_SEARCH_CHANGE = '@@b2b_portal_ui/superSearch/SUPER_SEARCH_CHANGE';
export const SUPER_SEARCH_TOGGLE = '@@b2b_portal_ui/superSearch/SUPER_SEARCH_TOGGLE';
/**
 * Api
 */
export const SUPER_SEARCH_START = '@@b2b_portal_ui/superSearch/SUPER_SEARCH_START';
export const SUPER_SEARCH_SUCCESSFUL = '@@b2b_portal_ui/superSearch/SUPER_SEARCH_SUCCESSFUL';
export const SUPER_SEARCH_EMPTY = '@@b2b_portal_ui/superSearch/SUPER_SEARCH_EMPTY';
export const SUPER_SEARCH_FAILED = '@@b2b_portal_ui/superSearch/SUPER_SEARCH_FAILED';
